<img class="watermarkImg" src="./assets/images/psh-watermark.png" alt="watermark">

<section class="sponsorChildSec">
  
  <div class="container">    
    <h1>Open Your Heart: Choose a Child to Sponsor</h1>
    <p class="sponsorDesc">Explore the stories of our children and make a meaningful impact in one's life.</p>
    <form *ngIf="!isMobile" class="filterForm" #filterForm='ngForm'>
      <div class="filtersWrapper">
        <div class="singleFilter">
          <label for="genderFilter">Gender</label>
          <ng-select class="sponsorSelect blueScroll" [items]="genderOptions" [(ngModel)]="filters.gender" name="genderFilter"
            id="genderFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false"
            (change)="rerender()">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="ageFilter">Age</label>
          <ng-select class="sponsorSelect blueScroll" [items]="ageOptions" [(ngModel)]="filters.age" name="ageFilter"
            id="ageFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false"
            (change)="rerender()">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="monthFilter">Birth Month</label>
          <ng-select class="sponsorSelect" [items]="monthOptions" [(ngModel)]="filters.month" name="monthFilter"
            id="monthFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false"
            (change)="rerender()">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="dayFilter">Birth Day</label>
          <ng-select class="sponsorSelect" [items]="dateOptions" [(ngModel)]="filters.day" name="dayFilter"
            id="dayFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false"
            (change)="rerender()">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="waitingPeriod">Waiting period</label>
          <ng-select class="sponsorSelect" [items]="waitingOptions" [(ngModel)]="filters.waiting" name="waitingPeriod"
            id="waitingPeriod" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false"
            (change)="rerender()">

          </ng-select>
        </div>
        <button class="clearBtn" (click)="clearAll()">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.22339 11.9856L14.6484 6.5606C14.9293 6.27914 15.0871 5.89772 15.0871 5.50005C15.0871 5.10238 14.9293 4.72096 14.6484 4.4395L11.5622 1.35375C11.2808 1.07282 10.8994 0.915039 10.5017 0.915039C10.104 0.915039 9.7226 1.07282 9.44114 1.35375L4.01614 6.77875C3.83694 6.95873 3.70652 7.18137 3.63716 7.42569C3.5678 7.67001 3.56179 7.92797 3.61969 8.17525L1.54809 10.2469C1.26715 10.5285 1.10938 10.9101 1.10938 11.3079C1.10938 11.7057 1.26715 12.0873 1.54809 12.3689L3.63309 14.4539C3.77301 14.5939 3.93934 14.7048 4.12244 14.78C4.30553 14.8552 4.50175 14.8933 4.69969 14.8921C4.7846 14.9624 4.89147 15.0006 5.00169 15.0003H12.0017C12.1343 15.0003 12.2615 14.9476 12.3552 14.8538C12.449 14.76 12.5017 14.6329 12.5017 14.5003C12.5017 14.3676 12.449 14.2405 12.3552 14.1467C12.2615 14.0529 12.1343 14.0003 12.0017 14.0003H6.20874L7.82674 12.3823C8.07406 12.4401 8.33206 12.4341 8.57641 12.3647C8.82076 12.2953 9.04341 12.1649 9.22339 11.9856ZM2.25534 11.6619C2.1616 11.5679 2.10896 11.4406 2.10896 11.3079C2.10896 11.1751 2.1616 11.0478 2.25534 10.9539L4.16309 9.04615L6.95604 11.8391L5.04834 13.7469C4.95274 13.8374 4.82609 13.8878 4.69444 13.8878C4.56278 13.8878 4.43613 13.8374 4.34054 13.7469L2.25534 11.6619Z"
              fill="#1C5084" />
          </svg>
          <span>Clear All</span>
        </button>
      </div>
    </form>

    <div class="filtersBtnsWrapper" *ngIf="isMobile">
      <button class="singleToggler" (click)="toggleFiltersModal('genderModal')">
        <div class="togglerName">Gender</div>
        <div class="toggleValue">
          <p>{{ filters.gender == '' ? 'Any' : filters.gender }}</p>
          <span></span>
        </div>
      </button>
      <button class="singleToggler" (click)="toggleFiltersModal('ageModal')">
        <div class="togglerName">Age</div>
        <div class="toggleValue">
          <p>{{ filters.age == '' ? 'Any' : filters.age }}</p>
          <span></span>
        </div>
      </button>
      <button class="singleToggler" (click)="toggleFiltersModal('monthModal')">
        <div class="togglerName">Birth Month</div>
        <div class="toggleValue">
          <p>{{ filters.month == '' ? 'Any' : filters.month }}</p>
          <span></span>
        </div>
      </button>
      <button class="singleToggler" (click)="toggleFiltersModal('dayModal')">
        <div class="togglerName">Birth Day</div>
        <div class="toggleValue">
          <p>{{ filters.day == '' ? 'Any' : filters.day }}</p>
          <span></span>
        </div>
      </button>
      <button class="singleToggler" (click)="toggleFiltersModal('waitingModal')">
        <div class="togglerName">Waiting Period</div>
        <div class="toggleValue">
          <p>{{ filters.waiting == '' ? 'Any' : filters.waiting }}</p>
          <span></span>
        </div>
      </button>
      <button class="clearBtn" (click)="clearAll()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9.22339 11.9856L14.6484 6.5606C14.9293 6.27914 15.0871 5.89772 15.0871 5.50005C15.0871 5.10238 14.9293 4.72096 14.6484 4.4395L11.5622 1.35375C11.2808 1.07282 10.8994 0.915039 10.5017 0.915039C10.104 0.915039 9.7226 1.07282 9.44114 1.35375L4.01614 6.77875C3.83694 6.95873 3.70652 7.18137 3.63716 7.42569C3.5678 7.67001 3.56179 7.92797 3.61969 8.17525L1.54809 10.2469C1.26715 10.5285 1.10938 10.9101 1.10938 11.3079C1.10938 11.7057 1.26715 12.0873 1.54809 12.3689L3.63309 14.4539C3.77301 14.5939 3.93934 14.7048 4.12244 14.78C4.30553 14.8552 4.50175 14.8933 4.69969 14.8921C4.7846 14.9624 4.89147 15.0006 5.00169 15.0003H12.0017C12.1343 15.0003 12.2615 14.9476 12.3552 14.8538C12.449 14.76 12.5017 14.6329 12.5017 14.5003C12.5017 14.3676 12.449 14.2405 12.3552 14.1467C12.2615 14.0529 12.1343 14.0003 12.0017 14.0003H6.20874L7.82674 12.3823C8.07406 12.4401 8.33206 12.4341 8.57641 12.3647C8.82076 12.2953 9.04341 12.1649 9.22339 11.9856ZM2.25534 11.6619C2.1616 11.5679 2.10896 11.4406 2.10896 11.3079C2.10896 11.1751 2.1616 11.0478 2.25534 10.9539L4.16309 9.04615L6.95604 11.8391L5.04834 13.7469C4.95274 13.8374 4.82609 13.8878 4.69444 13.8878C4.56278 13.8878 4.43613 13.8374 4.34054 13.7469L2.25534 11.6619Z"
            fill="#1C5084" />
        </svg>
        <span>Clear All</span>
      </button>
      <div class="allFiltersBtnWrapper">
        <button class="allFiltersToggler" (click)="toggleFiltersModal('allFilters')">
          <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_3641_3617)">
              <path
                d="M0.40625 2.29217H6.59153C6.77795 3.1407 7.53571 3.77772 8.43941 3.77772C9.34311 3.77772 10.1009 3.14072 10.2873 2.29217H12.5938C12.8181 2.29217 13 2.11027 13 1.88592C13 1.66157 12.8181 1.47967 12.5938 1.47967H10.2871C10.1003 0.631572 9.34152 -0.00585938 8.43941 -0.00585938C7.53683 -0.00585938 6.77838 0.631471 6.59169 1.47967H0.40625C0.181898 1.47967 0 1.66157 0 1.88592C0 2.11027 0.181898 2.29217 0.40625 2.29217ZM7.36016 1.88699C7.36016 1.88554 7.36018 1.88407 7.36018 1.88262C7.36196 1.28932 7.84608 0.806666 8.43941 0.806666C9.0319 0.806666 9.51605 1.28866 9.51861 1.88168L9.51869 1.88765C9.51775 2.48197 9.03396 2.96525 8.43941 2.96525C7.84512 2.96525 7.36148 2.48245 7.36013 1.88848L7.36016 1.88699ZM12.5938 10.7087H10.2871C10.1003 9.86061 9.34152 9.22315 8.43941 9.22315C7.53683 9.22315 6.77838 9.86051 6.59169 10.7087H0.40625C0.181898 10.7087 0 10.8906 0 11.1149C0 11.3393 0.181898 11.5212 0.40625 11.5212H6.59153C6.77795 12.3697 7.53571 13.0067 8.43941 13.0067C9.34311 13.0067 10.1009 12.3697 10.2873 11.5212H12.5938C12.8181 11.5212 13 11.3393 13 11.1149C13 10.8906 12.8181 10.7087 12.5938 10.7087ZM8.43941 12.1942C7.84512 12.1942 7.36148 11.7114 7.36013 11.1175L7.36016 11.116C7.36016 11.1145 7.36018 11.1131 7.36018 11.1116C7.36196 10.5183 7.84608 10.0357 8.43941 10.0357C9.0319 10.0357 9.51605 10.5176 9.51861 11.1106L9.51869 11.1166C9.51783 11.711 9.03401 12.1942 8.43941 12.1942ZM12.5938 6.09419H6.40847C6.22205 5.24566 5.46429 4.60866 4.56059 4.60866C3.65688 4.60866 2.89913 5.24566 2.71271 6.09419H0.40625C0.181898 6.09419 0 6.27609 0 6.50044C0 6.72481 0.181898 6.90669 0.40625 6.90669H2.71291C2.89971 7.75476 3.65848 8.39222 4.56059 8.39222C5.46317 8.39222 6.22162 7.75486 6.40831 6.90669H12.5938C12.8181 6.90669 13 6.72481 13 6.50044C13 6.27609 12.8181 6.09419 12.5938 6.09419ZM5.63984 6.49937C5.63984 6.50084 5.63982 6.50229 5.63982 6.50374C5.63804 7.09704 5.15392 7.57969 4.56059 7.57969C3.9681 7.57969 3.48395 7.0977 3.48138 6.5047L3.48131 6.49876C3.4822 5.90437 3.96602 5.42116 4.56059 5.42116C5.15488 5.42116 5.63852 5.90394 5.63987 6.49792L5.63984 6.49937Z"
                fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_3641_3617">
                <rect width="13" height="13" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
      </div>
    </div>

    <div class="breadcrum dark" >
      <div class="crumbs">   
        <div class="BreadcrumbList">       
          <p> <a href="javascript:;" routerLink="/" >Home</a> </p><span> &gt; </span>       
          <p> <a href="javascript:;" routerLink="/sponsorship-program" >Sponsorship Program</a> </p><span> &gt; </span>       
          <p>All Profiles</p>   
        </div>
      </div>                 
    </div>

    <div class="noDataScreen" *ngIf="orphans && !orphans.length && !loading">
      <svg width="102" height="102" viewBox="0 0 102 102" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M87.6562 22.834H19.125C16.4842 22.834 14.3438 24.9744 14.3438 27.6152V37.1777H87.6562V22.834Z" fill="#A5BBD7"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M87.6562 20.1445C87.6562 17.5037 85.5158 15.3633 82.875 15.3633C76.135 15.3633 63.9843 15.3633 57.8866 15.3633C55.5996 15.3633 53.4862 16.5889 52.3515 18.5747C50.4693 21.8706 47.8125 26.5195 47.8125 26.5195H87.6562V20.1445Z" fill="#A5BBD7"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3438 27.3125H87.6562V30.2817H14.3438V27.3125Z" fill="#8DA3BE"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M93.0226 36.5149C93.276 34.6884 92.7262 32.8413 91.5165 31.4515C90.3053 30.0602 88.5521 29.2617 86.7082 29.2617C70.4583 29.2617 31.5389 29.2617 15.289 29.2617C13.4451 29.2617 11.6919 30.0602 10.4807 31.4515C9.27103 32.8413 8.72119 34.6884 8.9746 36.5149C10.5907 48.1492 13.7272 70.7295 15.1727 81.1399C15.611 84.2907 18.3044 86.6367 21.4871 86.6367H80.5101C83.6928 86.6367 86.3862 84.2907 86.8245 81.1399C88.27 70.7295 91.4065 48.1492 93.0226 36.5149Z" fill="#CADCF0"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5101 40.3717C9.62963 39.0442 10.1619 37.7755 11.0528 36.7523C12.2625 35.3626 14.0156 34.5641 15.8596 34.5641H86.1376C87.9816 34.5641 89.7347 35.3626 90.9443 36.7523C91.8353 37.7755 92.3676 39.0442 92.4871 40.3717L93.0226 36.5149C93.276 34.6884 92.7262 32.8413 91.5165 31.4515C90.3053 30.0602 88.5521 29.2617 86.7082 29.2617C70.4583 29.2617 31.5389 29.2617 15.289 29.2617C13.4451 29.2617 11.6919 30.0602 10.4807 31.4515C9.27103 32.8413 8.72119 34.6884 8.9746 36.5149L9.5101 40.3717Z" fill="#E9F3FC"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M43.8281 70.7383C43.8281 68.9788 42.4017 67.5508 40.6406 67.5508C37.1041 67.5508 31.4287 67.5508 27.8906 67.5508C26.1311 67.5508 24.7031 68.9788 24.7031 70.7383V73.9258C24.7031 75.6869 26.1311 77.1133 27.8906 77.1133H40.6406C42.4017 77.1133 43.8281 75.6869 43.8281 73.9258C43.8281 72.901 43.8281 71.7647 43.8281 70.7383Z" fill="#105193"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M67.7344 40.7988C58.4986 40.7988 51 48.2974 51 57.5332C51 66.769 58.4986 74.2676 67.7344 74.2676C76.9702 74.2676 84.4688 66.769 84.4688 57.5332C84.4688 48.2974 76.9702 40.7988 67.7344 40.7988ZM67.7344 45.5801C74.3309 45.5801 79.6875 50.9367 79.6875 57.5332C79.6875 64.1297 74.3309 69.4863 67.7344 69.4863C61.1378 69.4863 55.7812 64.1297 55.7812 57.5332C55.7812 50.9367 61.1378 45.5801 67.7344 45.5801Z" fill="#105193"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M76.4493 69.0894L91.3158 83.9559C92.2497 84.8898 93.7638 84.8898 94.6977 83.9559C95.63 83.0235 95.63 81.5079 94.6977 80.5755L79.8312 65.709C78.8973 64.7767 77.3832 64.7767 76.4493 65.709C75.5169 66.6414 75.5169 68.157 76.4493 69.0894Z" fill="#105193"/>
        </svg>
        <p class="noDataHead">No Results Found</p>
        <div class="noDataDesc">We couldn’t find what you searched for. Try searching again.</div>
    </div>

    

    <div class="orphansWrapper">
      <ng-container *ngIf="!loading">
        <div [routerLink]="'/orphan-profiles/' + orphan.id " class="singleOrphan" *ngFor="let orphan of orphans">
          <div class="single_img">
            <canvas class="galleryCanvas"></canvas>
            <img class="galleryImg" [src]="orphan.child_picture" [alt]="orphan.name + 'img'">
          </div>
          <div class="orphanInformation">
            <p class="orphanName">{{ orphan.name }}</p>
            <div class="orphanAllDetails">
              <p class="orphanInfo">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="13" cy="13" r="13" fill="url(#paint0_linear_3394_2429)" />
                  <g clip-path="url(#clip0_3394_2429)">
                    <path
                      d="M19.886 15.8674V13.8009C19.8854 13.1671 19.3718 12.6535 18.738 12.6529H17.8196V10.3568C17.8196 10.23 17.7168 10.1272 17.59 10.1272H16.2123C16.0855 10.1272 15.9827 10.23 15.9827 10.3568V12.6529H13.9162V9.89758C13.9162 9.77078 13.8134 9.66797 13.6866 9.66797H12.309C12.1822 9.66797 12.0794 9.77078 12.0794 9.89758V12.6529H10.0129V10.3568C10.0129 10.23 9.91007 10.1272 9.78327 10.1272H8.40563C8.27883 10.1272 8.17602 10.23 8.17602 10.3568V12.6529H7.25759C6.62392 12.6535 6.11033 13.1671 6.10954 13.8009V15.8674C6.1017 16.3601 6.36673 16.817 6.79837 17.0549V19.5411H6.33915C6.21235 19.5411 6.10954 19.6439 6.10954 19.7707C6.10954 19.8975 6.21235 20.0003 6.33915 20.0003H19.6564C19.7832 20.0003 19.886 19.8975 19.886 19.7707C19.886 19.6439 19.7832 19.5411 19.6564 19.5411H19.1972V17.0584C19.6222 16.8119 19.8845 16.3586 19.886 15.8674ZM16.4419 10.5864H17.3603V12.6529H16.4419V10.5864ZM12.5386 10.1272H13.457V12.6529H12.5386V10.1272ZM8.63523 10.5864H9.55367V12.6529H8.63523V10.5864ZM6.56876 13.8009C6.56876 13.4204 6.87718 13.1121 7.25759 13.1121H18.738C19.1185 13.1121 19.4268 13.4204 19.4268 13.8009V15.8674C19.426 16.2321 19.2108 16.5622 18.8773 16.71C18.5302 16.8562 18.1293 16.781 17.8589 16.5188C17.6865 16.3458 17.5898 16.1115 17.59 15.8674V14.949C17.5888 14.6022 17.3921 14.2859 17.0816 14.1315L17.0676 14.1239C17.0308 14.1065 16.9929 14.0917 16.9542 14.0796C16.9313 14.072 16.9103 14.0645 16.8876 14.059C16.8582 14.0523 16.8285 14.047 16.7985 14.0433C16.7784 14.0404 16.7591 14.0343 16.7386 14.0328C16.7276 14.0328 16.717 14.0343 16.7063 14.0339C16.6954 14.0334 16.6835 14.0305 16.6715 14.0305C16.6461 14.0305 16.6215 14.0358 16.5963 14.0378C16.571 14.0399 16.5442 14.0411 16.5184 14.0454C16.4787 14.0528 16.4394 14.0629 16.4011 14.0755C16.3804 14.0819 16.3593 14.0865 16.3391 14.0943C16.2963 14.1117 16.2549 14.1324 16.2153 14.1563C16.2009 14.1646 16.1855 14.1706 16.1713 14.1793C16.1177 14.2141 16.0678 14.2543 16.0225 14.2994C15.8495 14.4711 15.7525 14.7051 15.7531 14.949V15.4082C15.7531 15.9154 15.342 16.3266 14.8347 16.3266C14.3275 16.3266 13.9162 15.9154 13.9162 15.4082V14.949C13.9151 14.6022 13.7183 14.2859 13.4079 14.1315L13.3939 14.1239C13.3571 14.1065 13.3192 14.0917 13.2804 14.0796C13.2576 14.072 13.2366 14.0645 13.2138 14.059C13.1845 14.0523 13.1547 14.047 13.1248 14.0433C13.1046 14.0404 13.0853 14.0343 13.0648 14.0328C13.0538 14.0328 13.0433 14.0343 13.0325 14.0339C13.0217 14.0334 13.0098 14.0305 12.9978 14.0305C12.9723 14.0305 12.9478 14.0358 12.9226 14.0378C12.8972 14.0399 12.8704 14.0411 12.8446 14.0454C12.8051 14.0528 12.7659 14.0629 12.7276 14.0755C12.7066 14.0819 12.6856 14.0865 12.6654 14.0943C12.6228 14.1117 12.5815 14.1323 12.542 14.1561C12.5274 14.1644 12.5118 14.1706 12.4975 14.1791C12.4439 14.2137 12.3941 14.2539 12.3488 14.2989C12.1757 14.4708 12.0787 14.705 12.0794 14.949V16.3266C12.0794 16.8338 11.6682 17.245 11.1609 17.245C10.6537 17.245 10.2425 16.8338 10.2425 16.3266V14.949C10.2414 14.6022 10.0446 14.2859 9.73417 14.1315L9.72015 14.1239C9.68338 14.1065 9.64549 14.0917 9.6067 14.0796C9.58382 14.072 9.56286 14.0645 9.5401 14.059C9.51073 14.0523 9.48102 14.047 9.45108 14.0433C9.4309 14.0404 9.41162 14.0343 9.3911 14.0328C9.3707 14.0312 9.34704 14.0305 9.32406 14.0305C8.81686 14.0305 8.40563 14.4416 8.40563 14.949V15.8674C8.40596 16.1107 8.30999 16.3442 8.13857 16.5169C7.91098 16.7359 7.58933 16.8272 7.28057 16.7603C7.22563 16.7486 7.17182 16.732 7.11991 16.7105C7.01497 16.6642 6.91934 16.5993 6.83772 16.5188C6.66529 16.3458 6.56865 16.1115 6.56876 15.8674V13.8009ZM7.25759 19.5411V17.226C7.28057 17.2298 7.30355 17.2308 7.32653 17.2335L7.34414 17.2354C7.54504 17.2561 7.74808 17.2326 7.9389 17.1664C7.9972 17.1459 8.05415 17.1215 8.1092 17.0935C8.12097 17.0877 8.13218 17.0815 8.1444 17.0751C8.18891 17.0509 8.23219 17.0243 8.27389 16.9954C8.28723 16.9863 8.30069 16.9778 8.31381 16.9681C8.66528 16.7124 8.87067 16.3019 8.86484 15.8674V14.949C8.86462 14.8271 8.91316 14.7103 8.9996 14.6245C9.02259 14.6017 9.04781 14.5813 9.07494 14.5638C9.07976 14.5609 9.08503 14.5588 9.08985 14.5561C9.11239 14.5423 9.13593 14.5305 9.16037 14.5209C9.16755 14.5182 9.17484 14.5165 9.18201 14.5143C9.20443 14.5067 9.22742 14.501 9.25085 14.497C9.26184 14.4952 9.27383 14.4948 9.28459 14.4936C9.30388 14.4918 9.32327 14.4911 9.34267 14.4915C9.35713 14.4922 9.37159 14.4937 9.38583 14.4959C9.4031 14.4979 9.42025 14.5011 9.43707 14.5053C9.44279 14.5067 9.44806 14.5088 9.45355 14.5104C9.65367 14.5834 9.78585 14.7747 9.78327 14.9877V16.3266C9.78327 17.0874 10.4001 17.7043 11.1609 17.7043C11.9218 17.7043 12.5386 17.0874 12.5386 16.3266V14.949C12.5386 14.793 12.6179 14.6478 12.7491 14.5636C12.753 14.5612 12.7576 14.5595 12.7616 14.557C12.7849 14.5428 12.8093 14.5305 12.8348 14.5207C12.8413 14.5182 12.8479 14.5168 12.8543 14.5147C12.8768 14.5071 12.8998 14.5011 12.9232 14.4968C12.9342 14.4952 12.9462 14.4946 12.9563 14.4936C12.9756 14.4916 12.9951 14.491 13.0146 14.4915C13.0291 14.4922 13.0434 14.4937 13.0578 14.4959C13.075 14.4979 13.0921 14.5011 13.109 14.5053C13.1147 14.5067 13.12 14.5088 13.1255 14.5104C13.3263 14.5828 13.4594 14.7743 13.457 14.9877V15.4082C13.457 16.169 14.0739 16.7858 14.8347 16.7858C15.5956 16.7858 16.2123 16.169 16.2123 15.4082V14.949C16.2121 14.8271 16.2606 14.7103 16.3471 14.6245C16.37 14.6017 16.3953 14.5813 16.4224 14.5638C16.4272 14.5609 16.4325 14.5588 16.4375 14.5558C16.46 14.5422 16.4835 14.5305 16.5078 14.5209C16.515 14.5182 16.5225 14.5165 16.5308 14.5143C16.5529 14.5067 16.5756 14.501 16.5985 14.497C16.6095 14.4952 16.6215 14.4948 16.6323 14.4936C16.6516 14.4918 16.671 14.4911 16.6904 14.4915C16.7048 14.4922 16.7193 14.4937 16.7335 14.4959C16.7508 14.4979 16.7679 14.5011 16.7848 14.5053C16.7905 14.5067 16.7957 14.5088 16.8012 14.5104C17.0012 14.5835 17.1334 14.7748 17.1307 14.9877V15.8674C17.1304 16.2333 17.2755 16.5845 17.5342 16.8434C17.5797 16.8878 17.6283 16.9291 17.6795 16.967C17.6944 16.9778 17.7098 16.9874 17.7255 16.9977C17.7641 17.0241 17.8031 17.0485 17.8437 17.0707C17.8598 17.0794 17.8758 17.088 17.8921 17.0959C17.9384 17.1189 17.9858 17.1393 18.0343 17.157C18.0439 17.1605 18.0533 17.1649 18.0632 17.1681C18.1892 17.2111 18.3206 17.2358 18.4536 17.2416H18.4551C18.5191 17.2441 18.5833 17.2422 18.6471 17.2358L18.6701 17.2333C18.693 17.2308 18.716 17.2298 18.739 17.226V19.5411H7.25759Z"
                      fill="#221F1F" />
                    <path
                      d="M12.9957 9.20846C13.6295 9.20768 14.1431 8.69408 14.1437 8.06042C14.1437 7.50927 13.3449 6.32479 13.1847 6.09305C13.1395 6.03442 13.0698 6 12.9957 6C12.9217 6 12.8519 6.03442 12.8068 6.09305C12.6465 6.32479 11.8477 7.50927 11.8477 8.06042C11.8484 8.69408 12.362 9.20768 12.9957 9.20846ZM12.9957 6.6386C13.3261 7.15499 13.6845 7.80962 13.6845 8.06042C13.6845 8.44082 13.3762 8.74924 12.9957 8.74924C12.6153 8.74924 12.3069 8.44082 12.3069 8.06042C12.3069 7.80962 12.6653 7.15499 12.9957 6.6386Z"
                      fill="#00AAE9" />
                    <path
                      d="M16.9019 9.66744C17.5357 9.66666 18.0493 9.15307 18.05 8.5194C18.05 7.96825 17.2512 6.78378 17.091 6.55204C17.0458 6.4934 16.9761 6.45898 16.9019 6.45898C16.828 6.45898 16.7581 6.4934 16.713 6.55204C16.5527 6.78378 15.7539 7.96825 15.7539 8.5194C15.7547 9.15307 16.2683 9.66666 16.9019 9.66744ZM16.9019 7.09758C17.2323 7.61398 17.5908 8.26861 17.5908 8.5194C17.5908 8.8998 17.2825 9.20823 16.9019 9.20823C16.5215 9.20823 16.2131 8.8998 16.2131 8.5194C16.2131 8.26861 16.5715 7.61398 16.9019 7.09758Z"
                      fill="#00AAE9" />
                    <path
                      d="M9.09335 9.66744C9.72713 9.66666 10.2407 9.15307 10.2414 8.5194C10.2414 7.96825 9.44259 6.78378 9.28238 6.55204C9.23719 6.4934 9.16746 6.45898 9.09335 6.45898C9.01936 6.45898 8.94951 6.4934 8.90444 6.55204C8.74412 6.78378 7.94531 7.96825 7.94531 8.5194C7.9461 9.15307 8.45969 9.66666 9.09335 9.66744ZM9.09335 7.09758C9.42375 7.61398 9.78218 8.26861 9.78218 8.5194C9.78218 8.8998 9.47387 9.20823 9.09335 9.20823C8.71295 9.20823 8.40453 8.8998 8.40453 8.5194C8.40453 8.26861 8.76296 7.61398 9.09335 7.09758Z"
                      fill="#00AAE9" />
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_3394_2429" x1="13" y1="0" x2="13" y2="26"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F5F6FD" />
                      <stop offset="1" stop-color="#F1F8FF" />
                    </linearGradient>
                    <clipPath id="clip0_3394_2429">
                      <rect width="14" height="14" fill="white" transform="translate(6 6)" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{{ orphan.dob | dobToAge }}</span>
              </p>
              <p class="orphanInfo">
                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="13" cy="13" r="13" fill="url(#paint0_linear_3394_2438)" />
                  <g clip-path="url(#clip0_3394_2438)">
                    <path
                      d="M13 6C9.14027 6 6 9.14027 6 13C6 16.8597 9.14027 20 13 20C16.8597 20 20 16.8597 20 13C20 9.14027 16.8597 6 13 6ZM13 19.125C9.62262 19.125 6.875 16.3774 6.875 13C6.875 9.62262 9.62262 6.875 13 6.875C16.3774 6.875 19.125 9.62262 19.125 13C19.125 16.3774 16.3774 19.125 13 19.125Z"
                      fill="#221F1F" stroke="#F4F6FD" stroke-width="0.3" />
                    <path d="M13.4375 8.625H12.5625V13.1811L15.3157 15.9343L15.9343 15.3157L13.4375 12.8188V8.625Z"
                      fill="#00AAE9" stroke="#F4F6FD" stroke-width="0.2" />
                  </g>
                  <defs>
                    <linearGradient id="paint0_linear_3394_2438" x1="13" y1="0" x2="13" y2="26"
                      gradientUnits="userSpaceOnUse">
                      <stop stop-color="#F5F6FD" />
                      <stop offset="1" stop-color="#F1F8FF" />
                    </linearGradient>
                    <clipPath id="clip0_3394_2438">
                      <rect width="14" height="14" fill="white" transform="translate(6 6)" />
                    </clipPath>
                  </defs>
                </svg>

                <span>{{ lastSponsoredDate(orphan.sponserd_date, orphan.is_sponsered ) }}</span>
              </p>
              <p class="orphanInfo oneLiner"> {{orphan.one_line_intro}} </p>
            </div>
            <a href="javascript:;"> Learn more about {{ orphan.name }} </a>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="loading || halfLoad">
        <div class="singleOrphan skeleton"></div>
        <div class="singleOrphan skeleton"></div>
        <div class="singleOrphan skeleton"></div>
        <div class="singleOrphan skeleton"></div>
        <div class="singleOrphan skeleton"></div>
        <div class="singleOrphan skeleton"></div>
      </ng-container>

    </div>

    <div class="showMoreBtnWrapper" *ngIf="!loading && countTo < countTotal">
      <button class="showMoreBtn" (click)="showMoreOrphans()">Show More Children
      </button>
      <span></span>
    </div>

  </div>
</section>

<ng-container *ngIf="isMobile">

  <div *ngIf="filtersOverlay" class="filterOverlay" (click)="hideFilterModals()"></div>

  <!-- Gender Modal -->
  <section class="filterModal" [ngClass]="genderModal ? 'show' : '' ">
    <div class="filtersTop">
      <p class="filterName">Gender</p>
      <a href="javascript:;">
        <img src="./assets/images/closeFilter.svg" alt="close btn" (click)="hideFilterModals()">
      </a>
    </div>
    <div class="filtersRadioBtns">
      <div class="singleRadioInput" *ngFor="let option of genderOptions">
        <input type="radio" [value]="option.value" name="genderRadio" [id]="'gender-'+option.label"
          [checked]="option.value == filters.gender" [(ngModel)]="filters.gender">
        <label [for]="'gender-'+option.label">
          <span class="radioName"> {{ option.label }} </span>
          <span class="radioStatus"></span>
        </label>
      </div>
    </div>
    <div class="applyBtnWrapper">
      <button class="mobApplyNow" (click)="rerender(); hideFilterModals();">Apply</button>
    </div>
  </section>

  <!-- Age Modal -->
  <section class="filterModal" [ngClass]="ageModal ? 'show' : '' ">
    <div class="filtersTop">
      <p class="filterName">Age</p>
      <a href="javascript:;">
        <img src="./assets/images/closeFilter.svg" alt="close btn" (click)="hideFilterModals()">
      </a>
    </div>
    <div class="filtersRadioBtns">
      <div class="singleRadioInput" *ngFor="let option of ageOptions">
        <input type="radio" [value]="option.value" name="ageRadio" [id]="'age-'+option.label"
          [checked]="option.value == filters.age" [(ngModel)]="filters.age">
        <label [for]="'age-'+option.label">
          <span class="radioName"> {{ option.label }} </span>
          <span class="radioStatus"></span>
        </label>
      </div>
    </div>
    <div class="applyBtnWrapper">
      <button class="mobApplyNow" (click)="rerender(); hideFilterModals();">Apply</button>
    </div>
  </section>

  <!-- Month Modal -->
  <section class="filterModal" [ngClass]="monthModal ? 'show' : '' ">
    <div class="filtersTop">
      <p class="filterName">Birth Month</p>
      <a href="javascript:;">
        <img src="./assets/images/closeFilter.svg" alt="close btn" (click)="hideFilterModals()">
      </a>
    </div>
    <div class="filtersRadioBtns">
      <div class="singleRadioInput" *ngFor="let option of monthOptions">
        <input type="radio" [value]="option.value" name="monthRadio" [id]="'month-'+option.label"
          [checked]="option.value == filters.month" [(ngModel)]="filters.month">
        <label [for]="'month-'+option.label">
          <span class="radioName"> {{ option.label }} </span>
          <span class="radioStatus"></span>
        </label>
      </div>
    </div>
    <div class="applyBtnWrapper">
      <button class="mobApplyNow" (click)="rerender(); hideFilterModals();">Apply</button>
    </div>
  </section>

  <!-- Day Modal -->
  <section class="filterModal" [ngClass]="dayModal ? 'show' : '' ">
    <div class="filtersTop">
      <p class="filterName">Birth Day</p>
      <a href="javascript:;">
        <img src="./assets/images/closeFilter.svg" alt="close btn" (click)="hideFilterModals()">
      </a>
    </div>
    <div class="filtersRadioBtns">
      <div class="singleRadioInput" *ngFor="let option of dateOptions">
        <input type="radio" [value]="option.value" name="dayRadio" [id]="'day-'+option.label"
          [checked]="option.value == filters.day" [(ngModel)]="filters.day">
        <label [for]="'day-'+option.label">
          <span class="radioName"> {{ option.label }} </span>
          <span class="radioStatus"></span>
        </label>
      </div>
    </div>
    <div class="applyBtnWrapper">
      <button class="mobApplyNow" (click)="rerender(); hideFilterModals();">Apply</button>
    </div>
  </section>

  <!-- Waiting Modal -->
  <section class="filterModal" [ngClass]="waitingModal ? 'show' : '' ">
    <div class="filtersTop">
      <p class="filterName">Waiting Period</p>
      <a href="javascript:;">
        <img src="./assets/images/closeFilter.svg" alt="close btn" (click)="hideFilterModals()">
      </a>
    </div>
    <div class="filtersRadioBtns">
      <div class="singleRadioInput" *ngFor="let option of waitingOptions">
        <input type="radio" [value]="option.value" name="waitingRadio" [id]="'waiting-'+option.label"
          [checked]="option.value == filters.waiting" [(ngModel)]="filters.waiting">
        <label [for]="'waiting-'+option.label">
          <span class="radioName"> {{ option.label }} </span>
          <span class="radioStatus"></span>
        </label>
      </div>
    </div>
    <div class="applyBtnWrapper">
      <button class="mobApplyNow" (click)="rerender(); hideFilterModals();">Apply</button>
    </div>
  </section>

  <!-- All Filters -->
  <section class="filterModal allFiltersModal" [ngClass]="allFilters ? 'show' : '' ">
    <div class="filtersTop">
      <p class="filterName">All Filters</p>
      <a href="javascript:;">
        <img src="./assets/images/closeFilter.svg" alt="close btn" (click)="hideFilterModals()">
      </a>
    </div>
    <form class="filterForm" #filterForm='ngForm'>
      <div class="filtersWrapper">
        <div class="singleFilter">
          <label for="genderFilter">Gender</label>
          <ng-select class="sponsorSelect" [items]="genderOptions" [(ngModel)]="filters.gender" name="genderFilter"
            id="genderFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="ageFilter">Age</label>
          <ng-select class="sponsorSelect" [items]="ageOptions" [(ngModel)]="filters.age" name="ageFilter"
            id="ageFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="monthFilter">Birth Month</label>
          <ng-select class="sponsorSelect" [items]="monthOptions" [(ngModel)]="filters.month" name="monthFilter"
            id="monthFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="dayFilter">Birth Day</label>
          <ng-select class="sponsorSelect" [items]="dateOptions" [(ngModel)]="filters.day" name="dayFilter"
            id="dayFilter" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false">

          </ng-select>
        </div>
        <div class="singleFilter">
          <label for="waitingPeriod">Waiting period</label>
          <ng-select class="sponsorSelect" [items]="waitingOptions" [(ngModel)]="filters.waiting" name="waitingPeriod"
            id="waitingPeriod" bindLabel="label" bindValue="value" [searchable]="false" [clearable]="false">

          </ng-select>
        </div>
      </div>
    </form>
    <div class="allFiltersWrapper"></div>
    <div class="applyBtnWrapper">
      <button class="mobApplyNow" (click)="rerender(); hideFilterModals();">Apply</button>
    </div>
  </section>



</ng-container>
